import MenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { forwardRef } from 'react';

const PREFIX = 'ConditionalMenuItem';

const classes = {
  menuItem: `${PREFIX}-menuItem`,
};

const StyledMenuItem = styled(MenuItem)(() => ({
  [`&.${classes.menuItem}`]: {
    '&.Mui-disabled': {
      pointerEvents: 'auto',
    },
  },
}));

// issue using vanilla MenuItemProps https://github.com/mui-org/material-ui/issues/16245
interface ConditionalMenuItemProps extends MenuItemProps<'li', { button?: true }> {
  disabledReason: string;
}

const ConditionalMenuItem = ({ disabledReason, ...menuItemProps }: ConditionalMenuItemProps, ref: any) => {
  if (menuItemProps.disabled) {
    return (
      (
        <Tooltip title={disabledReason}>
          <StyledMenuItem ref={ref} className={classes.menuItem} {...menuItemProps} />
        </Tooltip>
      )
    );
  }

  return (
    <MenuItem ref={ref} className={classes.menuItem} {...menuItemProps} />
  );
};

// Ref needs to be forwarded on to the Menu Item
export default forwardRef(ConditionalMenuItem);
